import React, {Component} from 'react';
import logo from '../../../../src/assets/images/KeolisLogo.png';

require('./common.scss');
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import {logoutAction,closePopupMessage} from '../../actions/index';
import { Modal } from "react-bootstrap";
import Timer from './Timer';

/** common header section of the webpage */
class Header extends Component {
    
    //onclick logout the onLogout() function executes
    onLogout(){
        this.props.onLogout();
    }
    render() {
        var empName = this.props.auth.name,empId = '';
        var firstname = '', lastname='';
        if (this.props.workdays && this.props.workdays.length>0 || empName != '') {            
            var splitEmpFullName = empName.split('.'),
            firstname = splitEmpFullName[0],
            lastname = splitEmpFullName[1]
        }
        if(this.props.auth.employeeID){
            empId = this.props.auth.employeeID;
        }
let loggedUser = this.props.auth.userName.split('@');
           let loggedUserName = loggedUser[0].replace('.', ' ');

        // executes the render function in the form of html
        return (
            <div className="headerBorder"> 
                <div className="sideNav" onClick={this.props.toggleSidebar()}>
                    <span className="fa fa-bars fa-4"></span>

                </div>
                <img className="logoImage" src={logo} />
                <div className="userDetail">
                    <span className="headName">{firstname} {lastname}</span>
                    <span className="headEmployeeId">{this.props.auth.role == 'Admin' ? '' : ':'}{empId}
                    {this.props.auth.impersonateUserId > 0 &&
                    <span className="claim-color">
                     - {loggedUserName} Logged in as employee id : {this.props.auth.impersonateUserId} </span>}
                    </span>
                    <i className="fa fa-sign-out logOutIcon" aria-hidden="true" onClick={() => this.onLogout()}></i>
                </div>
                <Timer />
                <Modal className='logoutpopupmessage' show={this.props.showAlert} onHide={() => this.props.closePopupMessage()} >
                    <Modal.Header closeButton>
                        Error !!!
                    </Modal.Header>
                    <Modal.Body>
                        {this.props.alertMsg ? this.props.alertMsg : 'You are no longer allowed to do any edits.' } You will be logged out.
                    </Modal.Body>
                </Modal>
            </div>
        );
    }
}

//from store to component
function mapStateToProps(state) {
    return {
       workdays: state.workdays.workdays,
       auth:state.authState,
       showAlert : state.popupmessage.show,
       alertMsg : state.popupmessage.message
    };
}

//from component that dispatches to store
function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            onLogout:logoutAction,
            closePopupMessage:closePopupMessage
        }, dispatch);
}

//export and connect both mapStateToProps & matchDispatchToProps
export default connect(mapStateToProps, matchDispatchToProps)(Header);

